import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const RiderCard = ({ rider, selected, onSelect }) => (
  <button
    type="button"
    onClick={onSelect}
    className={`w-full rounded-[12px] p-3 text-left bg-[#eadfb7] ${
      selected ? "ring-2 ring-[#5d4037]" : ""
    }`}
  >
    <div className="flex items-center">
      <img
        alt=""
        className="w-9 h-9 rounded-full object-cover"
        src="https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=200&q=80&auto=format&fit=crop"
      />
      <div className="ml-3">
        <p className="font-bold leading-4">{rider.name}</p>
        <p className="text-[13px] leading-4">Rider ID: {rider.id}</p>
        <p className="text-[13px] leading-4">{rider.distance} miles away</p>
        <p className="text-[13px] leading-4">Delivering orders: {rider.orders}</p>
      </div>
      <div className="ml-auto">
        {selected ? (
          <div className="w-7 h-7 rounded-full bg-[#5d4037] grid place-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#fff8e1"><path d="M20 6L9 17l-5-5"/></svg>
          </div>
        ) : (
          <div className="w-7 h-7 rounded-full border border-[#5d4037]" />
        )}
      </div>
    </div>
  </button>
);

export const AvailableRiders = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(3); 
  const [showSheet, setShowSheet] = useState(false);

  const riders = [
    { name: "Ron Hellion", id: 7632, distance: "3.1", orders: 1 },
    { name: "Ron Hellion", id: 7632, distance: "3.1", orders: 1 },
    { name: "Ron Hellion", id: 7632, distance: "3.1", orders: 1 },
    { name: "Ron Hellion", id: 7632, distance: "3.1", orders: 1 },
  ];

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="relative app-container [font-family:'Nunito',Helvetica] text-[#5d4037] pb-40">
        {/* Topbar */}
        <div className="w-full flex items-center mt-4">
          <button onClick={() => navigate(-1)} className="ml-4 w-9 h-9 rounded-full bg-[#ccb357] grid place-items-center" aria-label="Back">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
          </button>
          <h1 className="flex-1 text-center font-bold text-[18px]">Assign Rider</h1>
          <div className="w-9" />
        </div>

        {/* Order summary */}
        <div className="px-4 mt-4">
          <div className="rounded-[12px] bg-[#eadfb7] p-3">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-bold">Ken Brown</p>
                <p className="text-[13px] mt-1">ken456@gmai.com</p>
                <p className="text-[13px]">March 4, 2025 · 10:21 AM</p>
                <p className="text-[13px]">07012548935</p>
                <span className="inline-block mt-2 text-[12px] px-2 py-1 rounded-full bg-[#f7e8a6] text-[#7d5d00]">Pending</span>
              </div>
              <p className="font-bold">₦12,000</p>
            </div>
          </div>
        </div>

        {/* Title */}
        <p className="px-4 mt-5 font-extrabold">Available Riders</p>

        {/* List */}
        <div className="px-4 mt-3 space-y-4">
          {riders.map((r, i) => (
            <RiderCard
              key={i}
              rider={r}
              selected={selected === i}
              onSelect={() => setSelected(i)}
            />
          ))}
        </div>

        {/* Confirm */}
        <div className="px-4 mt-6 flex justify-center">
          <button
            onClick={() => setShowSheet(true)}
            className="w-[290px] h-[56px] rounded-[28px] bg-[#f7c945] font-bold text-[#5d4037] hover:opacity-90 transition-opacity"
          >
            Confirm
          </button>
        </div>

        {/* spacer */}
        <div className="h-6" />

        {/* Safe-area bar */}
        <div className="fixed bottom-3 md:bottom-6 left-1/2 -translate-x-1/2 w-full max-w-[1440px] xl:max-w-[1600px] px-6 md:px-10 xl:px-16 pointer-events-none">
          <div className="h-[22px] bg-[#5d4037] flex items-center justify-center">
            <div className="w-[120px] h-[6px] rounded-full bg-white" />
          </div>
        </div>

        {/* Assign Rider sheet (popup) */}
        {showSheet && (
          <div className="fixed inset-0 z-50">
            <div className="absolute inset-0 bg-black/30" onClick={() => setShowSheet(false)} />
            <div className="absolute left-1/2 -translate-x-1/2 bottom-[44px] w-[412px] bg-white rounded-t-[20px] p-6">
              <button
                aria-label="Close"
                onClick={() => setShowSheet(false)}
                className="absolute right-4 top-4 w-8 h-8 rounded-full bg-[#ccb357] grid place-items-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button>

              {/* scooter illustration circle */}
              <div className="w-full flex justify-center mt-3">
                <div className="w-[72px] h-[72px] rounded-full bg-[#f7c945] grid place-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="#5d4037">
                    <path d="M5 17a3 3 0 106 0H5zM16 17a3 3 0 106 0h-6zM11 17h5l2-6h-4l-1-3H7l1 3h3z"/>
                  </svg>
                </div>
              </div>

              <p className="text-center font-extrabold mt-4">Rider has been assigned</p>
              <p className="text-center text-[14px] mt-1">
                You can track delivery riders assigned<br/>to a customer
              </p>

              <div className="w-full flex justify-center">
                <button
                  className="mt-5 w-[260px] h-[48px] rounded-[24px] bg-[#f7c945] font-bold text-[#5d4037] hover:opacity-90"
                  onClick={() => navigate("/orders/live-tracking")}
                >
                  Track Rider
                </button>
              </div>

              <div className="w-full text-center mt-4">
                <button className="text-[#c34040] underline" onClick={() => navigate("/dashboard")}>
                  Back to home
                </button>
              </div>

            </div>
          </div>
        )}
      </div>
    </div>
  );
};
